import React from "react";
import PropTypes from "prop-types";
import "../../../styles/colorCheckbox.scss";

const ColorCheckbox = ({
                           className = "",
                           value = false,
                           disabled = false,
                           title = "",
                           handleChange,
                           id
                       }) => {
    // Generate a unique ID if none provided
    const checkboxId = id || `${className.replace(/\s+/g, '-')}Checkbox`;

    // Combine class names based on state
    const containerClasses = [
        "color-checkbox",
        className,
        disabled ? "disabled" : "",
        value ? "checked" : ""
    ].filter(Boolean).join(" ");

    const handleClick = (e) => {
        e.preventDefault();
        if (!disabled && handleChange) {
            handleChange(!value);
        }
    };

    return (
        <div
            className={containerClasses}
            onClick={handleClick}
            role="checkbox"
            aria-checked={value}
            aria-disabled={disabled}
        >
            <input
                type="checkbox"
                checked={value}
                disabled={disabled}
                id={checkboxId}
                onChange={() => {}} // Controlled component
                aria-label={title}
            />
            <label
                htmlFor={checkboxId}
                className={disabled ? "disabled" : ""}
            >
                <span>{title}</span>
            </label>
        </div>
    );
};

ColorCheckbox.propTypes = {
    className: PropTypes.string,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    title: PropTypes.string.isRequired,
    handleChange: PropTypes.func,
    id: PropTypes.string
};

export default ColorCheckbox;